export default __webpack_public_path__ + "static/media/pigna.2ea652e1.webp";